{
  "user_invitations": {
    "navigation_title": "Invitaciones",
    "title": "Invitaciones de usuario",
    "list_title": "Invitaciones",
    "form_title": "Invitación para el usuario",
    "accept_form_title": "Aceptar invitación para el usuario",
    "user_created": "¡La cuenta de usuario se creó exitósamente! Puede iniciar sesión ahora",
    "create_new": "Invitar usuario",
    "save": "Enviar invitación",
    "go_to_index": "Regresar a las invitaciones",
    "empty_list": "No hay invitaciones para usuarios",
    "select_org": "Seleccione Invitar una organización",
    "resend": "Reenviar invitación"
  }
}
